import apiKeysEndpoints from './endpoints/apiKeys';
import c2paEndpoints from './endpoints/c2pa';
import commonEndpoints from './endpoints/common';
import contactEndpoints from './endpoints/contacts';
import dashboardEndpoints from './endpoints/dashboard';
import docxConversionEndpoints from './endpoints/docxConversion';
import documentsEndpoints from './endpoints/documents';
import invoicesEndpoints from './endpoints/invoices';
import kycEndpoints from './endpoints/kyc';
import oauthEndpoints from './endpoints/oauth';
import onboardingEndpoints from './endpoints/onboarding';
import organizationsEndpoints from './endpoints/organizations';
import pdfConversionEndpoints from './endpoints/pdfConversion';
import reviewEndpoints from './endpoints/review';
import safeTransfersEndpoints from './endpoints/safeTransfers';
import signEndpoints from './endpoints/sign';
import signingsEndpoints from './endpoints/signings';
import subscriptionEndpoints from './endpoints/subscription';
import templatesEndpoints from './endpoints/templates';
import usersEndpoints from './endpoints/users';

export const endpoints = {
  ...apiKeysEndpoints,
  ...c2paEndpoints,
  ...commonEndpoints,
  ...contactEndpoints,
  ...dashboardEndpoints,
  ...docxConversionEndpoints,
  ...documentsEndpoints,
  ...invoicesEndpoints,
  ...kycEndpoints,
  ...oauthEndpoints,
  ...onboardingEndpoints,
  ...organizationsEndpoints,
  ...pdfConversionEndpoints,
  ...reviewEndpoints,
  ...safeTransfersEndpoints,
  ...signEndpoints,
  ...signingsEndpoints,
  ...subscriptionEndpoints,
  ...templatesEndpoints,
  ...usersEndpoints,
} as const;

export type EndpointKey = keyof typeof endpoints;
